<template>
  <el-row>
    <el-col :span="12">
      <el-form-item label="起始日期" prop="StartDateTime">
        <el-date-picker v-model="value.StartDateTime" type="date" placeholder="选择起始日期" value-format="yyyy-MM-dd" size="small"> </el-date-picker>
      </el-form-item>
      <el-form-item label="日期格式" prop="Style">
        <el-select v-model.number="value.Style" size="small">
          <el-option v-for="o in StyleOption.opts" :key="o.code" :value="o.code" :label="o.text"></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="截止日期" prop="StartDateTime">
        <el-date-picker v-model="value.EndDateTime" type="date" value-format="yyyy-MM-dd" placeholder="选择截止日期" size="small"> </el-date-picker>
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>
  import { eProps } from "@/common/editorUtils";
  export default {
    props: {
      value: Object,
    },
    computed: {
      StyleOption() {
        return eProps.find((p) => p.code == "Style");
      },
    },
    watch: {
      value() {
        if (this.value.Style && !isNaN(this.value.Style)) {
          this.value.Style = Number(this.value.Style);
        }
      },
    },
  };
</script>
